function store(_storage) {
  const storage = _storage
  const get = (key) => {
    return storage.getItem(key)
  }

  const set = (key, val) => {
    storage.setItem(key, val)
  }
  return { get, set }
}

const storage = store(window.localStorage)

export { storage }
export default store(window.sessionStorage)
